
import wx from 'weixin-js-sdk';
import Loading from 'vux/src/components/loading/index.vue'
import Msg from 'vux/src/components/msg/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import {fetch,promptMessage } from '../../api/dataHandling';
export default {
data(){
return {
loadingShow:true,
msgicon: '',
msgTitle:'',
scheduleSource:'',
msgDescription:'',
buttons: [{
type: 'primary',
text: '关 闭',
onClick: this.changeIcon.bind(this)
}]
}
},
directives: {
TransferDom
},
components: {
Msg,Loading
},
methods:{
changeIcon () {
WeixinJSBridge.call("closeWindow");
},
getUserId(){
fetch('get',urlConfig.GetSfzh+'?openid='+this.$route.query.openid).then(response => {
this.getPersonInfoId(response.sfzh);

}).catch(error => {
console.log('error' + error)
})
},
getPersonInfoId(sfzh){
fetch('get',urlConfig.GetPersonInfoId+'?sfzh='+sfzh).then(response => {
console.log(response)
this.getweixinDate(locations,item);
}).catch(error => {
console.log('error' + error)
})

},
getweixinDate(locations,item){
var locations = locations.split(',');
var _this = this;
_this.scheduleSource = this.$route.query.scheduleSource;
axios.get('http://front.wh.jinxin-fertility.com/weixin/getsigninfo?url=' + encodeURIComponent(window.location.href)).then(response => {
this.weixindata = response.data;
wx.config({
debug: false,
appId: _this.weixindata.appId,
timestamp: _this.weixindata.timestamp,
nonceStr: _this.weixindata.noncestr,
signature: _this.weixindata.signature,
jsApiList: ['checkJsApi', 'openLocation', 'getLocation']
});
}).catch(function (error) {
console.log('error: ' +error)

})
_this.parmdata = {};
_this.parmdata = new URLSearchParams();
_this.parmdata.append('scheId',item.SCHEID)
_this.parmdata.append('schedualedDate',item.SCHEDATE)
_this.parmdata.append('shiftTime',item.SHIFTTIME)
_this.parmdata.append('schedulingDId',item.SCHEITEMID)
_this.parmdata.append('timeItemId',item.TIMEITEMID)
_this.parmdata.append('queuedm',item.QUEUEDM)
_this.parmdata.append('personInfoId', + _this.personInfoId)
_this.parmdata.append('areaId',item.AREAID)
_this.parmdata.append('scheduleSource',_this.scheduleSource)

wx.ready(function () {
wx.checkJsApi({
jsApiList: ['getLocation'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
success: function(res) {
}
});
wx.getLocation({
type:'wgs84',
success:function(res){
var latitude = res.latitude; 
var longitude = res.longitude; 
function toRad(d) {  return d * Math.PI / 180; }
function getDisance(lat1, lng1, lat2, lng2) {//lat为纬度, lng为经度, 一定不要弄错
var dis = 0;
var radLat1 = toRad(lat1);
var radLat2 = toRad(lat2);
var deltaLat = radLat1 - radLat2;
var deltaLng = toRad(lng1) - toRad(lng2);
var dis = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(deltaLat / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(deltaLng / 2), 2)));
return parseInt(dis * 6378137);
}

_this.Distancetest = getDisance(latitude,longitude,locations[0],locations[1]);
if(_this.Distancetest <500){
fetch('post','/myorders/signPatientSchedule',_this.parmdata).then(response => {
/*   console.log( response,'签到2')*/
if(response.resultCode == 'success'){
_this.msgicon = 'success';
_this.msgTitle = '签到成功！';
_this.msgDescription = ''
_this.loadingShow = false;
}else{
_this.msgicon = 'warn';
_this.msgTitle = '签到失败！';
_this.msgDescription = '请重新扫描二维码签到';
_this.loadingShow = false;
}

}).catch(error => {
_this.msgicon = 'warn';
_this.msgTitle = '签到失败！';
_this.msgDescription = '请重新扫描二维码签到';
_this.loadingShow = false;
})
}else {
_this.msgicon = 'warn';
_this.msgTitle = '签到失败！';
_this.msgDescription = '您不在指定签到点范围，请到签到点扫描二维码签到！'
_this.loadingShow = false;
}

}
});


});

},  //获取地理位置

},
mounted(){
/* this.getUserId();*/


}
}



// WEBPACK FOOTER //
// ./src/project/sweepProject/sweepSign.vue